import { render, staticRenderFns } from "./PhotoCategory.vue?vue&type=template&id=2047b15e&scoped=true"
import script from "./PhotoCategory.vue?vue&type=script&lang=js"
export * from "./PhotoCategory.vue?vue&type=script&lang=js"
import style0 from "./PhotoCategory.vue?vue&type=style&index=0&id=2047b15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2047b15e",
  null
  
)

export default component.exports